import { lazy } from 'react';

const OrderPage = lazy(() =>  import('../pages/Order/Order'));
const OrderEditPage = lazy(() =>  import('../pages/Order/OrderEdit'));
const NewOrderPage = lazy(() =>  import('../pages/Order/New'));
const CheckinPage = lazy(() =>  import('../pages/Order/Checkin'));
const CheckinComponentPage = lazy(() =>  import('../pages/Order/CheckinComponent'));
const CheckinNewPage = lazy(() =>  import('../pages/Order/CheckinNew'));
const CheckoutPage = lazy(() =>  import('../pages/Order/Checkout'));
const CheckoutNewPage = lazy(() =>  import('../pages/Order/CheckoutNew'));
const CheckoutComponentPage = lazy(() =>  import('../pages/Order/CheckoutComponent'));
const PrintPreview = lazy(() =>  import('../pages/Order/PrintPreview'));

const order = [{
    path: '/orders/add',
    element: NewOrderPage,
    exact: true,
    analytics: { name: ["Nuova commessa"] },
}, {
    path: '/orders/:orderId',
    element: OrderPage,
    analytics: { name: ["Commessa"] },
}, {
    path: '/orders/:orderId/edit',
    element: OrderEditPage,
    analytics: { name: ["Modifica commessa"] },
}, {
    path: '/orders/:orderId/check-in/new',
    element: CheckinNewPage,
    exact: true,
    analytics: { name: ["Commessa","Check-in","Nuovo"] },
}, {
    path: '/orders/:orderId/check-in/:eventId',
    element: CheckinPage,
    analytics: { name: ["Commessa","Check-in"] },
}, {
    path: '/orders/:orderId/check-in/:eventId/:questionsGroupId',
    element: CheckinComponentPage,
    analytics: { name: ["Commessa","Check-in","Componente"] },
}, {
    path: '/orders/:orderId/check-out/new',
    element: CheckoutNewPage,
    analytics: { name: ["Commessa","Check-out","Nuovo"] },
}, {
    path: '/orders/:orderId/check-out/:eventId',
    element: CheckoutPage,
    analytics: { name: ["Commessa","Check-out"] },
}, {
    path: '/orders/:orderId/check-out/:eventId/:questionsGroupId',
    element: CheckoutComponentPage,
    analytics: { name: ["Commessa","Check-out","Componente"] },
}, {
    path: '/orders/:orderId/print/:eventId',
    element: PrintPreview,
    analytics: { name: ["Commessa","Check-in"] },
}]

export default order;